<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1000px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Quality Management"
      text="Edit Quality Management"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="localQualityManagement.name"
                v-validate="'required'"
                :disabled="localQualityManagement.department_id?true:false"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="employeeSearchInput"
                placeholder="Filter employee by name"
                append-icon="search"
                label="Search Employee By Name"
                hide-no-data
                hide-selected
              />

              <v-autocomplete
                v-model="filters.departments"
                :items="departments"
                item-text="name"
                item-value="id"
                value="id"
                label="Search Employee By Department"
                placeholder="Filter employee by department"
                clearable
                hide-selected
                multiple
                deletable-chips
                small-chips
                chips
              />

              <v-data-table
                v-model="selectedEmployees"
                :items="filteredEmployees"
                :headers="employeeHeaders"
                hide-default-footer
                fixed-header
                disable-pagination
                show-select 
                dense
                item-key="employee_uid"
                item-value="employee_uid"
                :loading="loading"
                height="330px"
                class="elevation-2 mb-3"
              >
                <template v-slot:top>
                  <v-toolbar
                    flat
                    color="white"
                  >
                    <v-toolbar-title>Employee Selection:</v-toolbar-title>
                  </v-toolbar>
                </template>
              </v-data-table>
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="departmentSearchInput"
                placeholder="Filter department by name"
                append-icon="search"
                label="Search Department"
                hide-no-data
                hide-selected
              />

              <v-autocomplete
                disabled
                style="opacity:0"
              />
              
              <v-data-table
                v-model="selectedDepartments"
                :items="filteredDepartments"
                :headers="departmentHeaders"
                hide-default-footer
                fixed-header
                disable-pagination
                show-select 
                dense
                :loading="loading"
                height="330px"
                class="elevation-2 mb-3"
              >
                <template v-slot:top>
                  <v-toolbar
                    flat
                    color="white"
                  >
                    <v-toolbar-title>Department Selection:</v-toolbar-title>
                  </v-toolbar>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      qualityManagement: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localQualityManagement: null,
        loading: false,
        departments: [],
        employees: [],
        departmentHeaders: [
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
        ],
        employeeHeaders: [
          {
            text: 'Name',
            align: 'left',
            value: 'person.name',
          },       
        ],
        selectedDepartments: [],
        selectedEmployees: [],
        employeeSearchInput: '',
        departmentSearchInput: '',
        filters: {
          departments: '',
        },
      }
    },
    computed: {
      filteredEmployees () {
        let _this = this
        _this.employeeSearchInput = _this.employeeSearchInput.trim()
        let primaryFilterEmployees = this.employees.filter(function (employee) {
          return ((employee.person || {}).name || '').toLowerCase().indexOf(_this.employeeSearchInput.toLowerCase()) !== -1 ||
            ((employee.person || {}).username || '').toLowerCase().indexOf(_this.employeeSearchInput.toLowerCase()) !== -1
        })

        let filteredDepartments = this.customFilterDepartments(primaryFilterEmployees)
        return filteredDepartments
      },

      filteredDepartments () {
        let _this = this
        _this.departmentSearchInput = _this.departmentSearchInput.trim()
        let primaryFilterDepartments = this.departments.filter(function (department) {
          return ((department || {}).name || '').toLowerCase().indexOf(_this.departmentSearchInput.toLowerCase()) !== -1 
        })

        return primaryFilterDepartments
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        Promise.all([
          this.$api.employees().list('?with=active'),
          this.$api.departments().list(),
        ])
          .then(([employees, departments]) => {
            let temp = employees.data.filter(employee => {
              return employee.department_id !== null
            })

            this.employees = _.orderBy(temp, ['person.name', 'department.name'], ['asc', 'asc'])    
            
            let employeeResult = this.localQualityManagement.quality_management_employees.map(a => a.employee_uid)
            this.selectedEmployees = []
            this.selectedEmployees = this.employees.filter(employee => {            
              return _.intersection([employee.employee_uid], employeeResult).length > 0
            })

            this.departments = departments.data

            let departmentResult = this.localQualityManagement.quality_management_target_groups.map(a => a.groupable_id)
            this.selectedDepartments = []
            this.selectedDepartments = this.departments.filter(department => {            
              return _.intersection([department.id], departmentResult).length > 0
            })
          })
        this.localQualityManagement = { ...this.qualityManagement }

        this.loading = false
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)
            this.$api.qualityManagement().update(this.qualityManagement.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.message })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          name: this.localQualityManagement.name,
          employeeUids: this.getEmployeeUids(),
          departmentIds: this.getDepartmentIds(),
        }
      },

      getEmployeeUids () {
        let employeeUids = []

        this.selectedEmployees.map(item => {
          employeeUids.push(item.employee_uid)
        })

        return employeeUids
      },

      getDepartmentIds () {
        let departmentIds = []

        this.selectedDepartments.map(item => {
          departmentIds.push(item.id)
        })

        return departmentIds
      },
      customFilterDepartments (employeesList) {
        if (this.filters.departments.length === 0) return employeesList

        return employeesList.filter(employee => {
          return _.intersection([employee.department_id], this.filters.departments).length > 0
        })
      },
    },
  }
</script>
